import { MatchTheme } from '../Match2Theme';
import { ThemeDefinition } from 'src/game/theme/Theme';
import { Match2GoalsPanelNew } from 'src/game/minigame/match2-timestep/components/Match2GoalsPanelNew';
import { Match2MovesPanelNew } from 'src/game/minigame/match2-timestep/components/Match2MovesPanelNew';
import { Match2BoostersBarNew } from 'src/game/minigame/match2-timestep/components/Match2BoostersBarNew';
import { Match2ScoreProgressbarNew } from 'src/game/minigame/match2-timestep/components/Match2ScoreProgressbarNew';
import { user, now } from 'src/StateObserver';
import { getMatch2BackgroundMetadata } from 'src/replicant/match2/match2.getters';
import { SakuraEffect } from 'src/lib/effects/sakuraEffect';
import { LeafEffect } from 'src/lib/effects/leafEffect';
import { SnowEffect } from 'src/lib/effects/snowEffect';
import { RainEffect } from 'src/lib/effects/rainEffect';

export const v2Theme: ThemeDefinition<MatchTheme> = {
  // UI components.
  getGoalsPanel: (opts) => new Match2GoalsPanelNew({ ...opts, x: 20, y: 30 }),
  getLevelPanel: () => undefined,
  getMovesPanel: (opts) =>
    new Match2MovesPanelNew({ ...opts, x: (opts.x ?? 0) - 214, y: 30 }),
  getBoosterBar: (opts) => new Match2BoostersBarNew(opts),
  getScoreProgressbar: (opts) => new Match2ScoreProgressbarNew(opts),

  // Styles.
  getQuitButtonStyle: () => ({
    x: 640,
    offsetX: -50.5,
    offsetY: -25,
    width: 81,
    height: 88,
    centerOnOrigin: false,
    centerAnchor: true,
  }),
  getPetContainerStyle: () => ({}),
  getGameYOffset: () => -25,
  getPetContainerOffset: () => -80,

  // Assets URLs.
  getLevelBackground: () => {
    const backgroundFile = getMatch2BackgroundMetadata(user(), now()).image;
    return `assets/minigame/match2/bg/${backgroundFile}`;
  },
  getBoosterIcon: (type) => `assets/ui/match2/level/booster_${type}.png`,
  getUIAsset: (string) => `assets/ui/match2/level/${string}`,
  getAssets: () => [
    'assets/ui/match2/level/',
    'assets/ui/match2/goals/',
    v2Theme.getLevelBackground(),
    `assets/minigame/match2/puzzle/tiles/`,
    `assets/minigame/match2/puzzle/effects/fx.bullet/`,
    `assets/minigame/match2/puzzle/effects/fx.dart/`,
    `assets/minigame/match2/puzzle/effects/fx.drill/`,
  ],

  // Effects.
  getParticleEffect: (opts) => {
    const metadata = getMatch2BackgroundMetadata(user(), now());
    if (!metadata.effect) return undefined;

    switch (metadata.effect) {
      case 'sakura':
        return new SakuraEffect(opts);
      case 'leaf':
        return new LeafEffect(opts);
      case 'snow':
        return new SnowEffect(opts);
      case 'rain':
        return undefined; // new RainEffect(opts); - Temporary disabled
    }
  },
};
